module.exports = __webpack_public_path__ + "img/message-exchange.6ef6657c.png";